export type ContractValidateRes = {
  is_valid: boolean;
  message: string;
};

export type TaskStatusResponse = {
  task_id: string;
  status: ContractTaskStatus;
  progress: number;
  progress_message: string;
  error: string | null;
};

export enum ContractTaskStatus {
  PENDING = 'PENDING',
  STARTED = 'STARTED',
  ACCESSCONTROL = 'ACCESSCONTROL',
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
  RETRY = 'RETRY',
  REVOKED = 'REVOKED'
}

export enum ContractStatus {
  DRAFT = 'DRAFT',
  QUEUED = 'QUEUED',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  DELETING = 'DELETING'
}

export type Contract = {
  id: string;
  contract_id: string;
  name: string;
  owner: string;
  submitted_by?: string;
  environment: string;
  status: ContractStatus;
  source_type: string;
  destination_type: string;
  created_at: string;
  updated_at: string;
  yaml_content?: string;
  secret_name?: string | null;
  secret_type?: string | null;
  secret_error?: string | null;
};

export type LatestTaskInfo = {
  task_id: string;
  task_type: string;
  status: string;
  progress: number;
  progress_message: string | null;
  started_at: string | null;
  completed_at: string | null;
  error: string | null;
};

export type ContractStatusResponse = {
  contract_id: string;
  contract_name: string;
  contract_status: string;
  owner: string;
  environment: string;
  created_at: string | null;
  updated_at: string | null;
  latest_task: LatestTaskInfo | null;
};

export type ContractsListResponse = {
  contracts: Contract[];
  total: number;
};

export enum ValidationState {
  NONE = 'NONE',
  VALIDATING = 'VALIDATING',
  VALID = 'VALID',
  INVALID = 'INVALID',
  MODIFIED = 'MODIFIED'
}

// Parsed YAML structure types
export type DataContractInfo = {
  title: string;
  version: string;
  description?: string;
  owner?: string;
  contact?: {
    name?: string;
    url?: string;
  };
  slackChannel?: string;
  tenant?: string;
};

export type ServerConfig = {
  type: string;
  host?: string;
  port?: number;
  database?: string;
  schema?: string;
  secrets?: {
    type?: string;
    secret_name?: string;
    vault_url?: string;
    vault_path?: string;
  };
};

export type DataContractServers = {
  source?: ServerConfig;
  destination?: ServerConfig;
};

export type ModelField = {
  type: string;
  required?: boolean;
  unique?: boolean;
  primary?: boolean;
  description?: string;
  config?: Record<string, any>;
};

export type DataContractModel = {
  description?: string;
  type?: string;
  fields?: Record<string, ModelField>;
};

export type DataContractYAML = {
  dataContractSpecification?: string;
  id?: string;
  info?: DataContractInfo;
  servers?: DataContractServers;
  models?: Record<string, DataContractModel>;
  terms?: {
    usage?: string;
    limitations?: string;
  };
};
